angular.module("tikonApp")
    .directive("eoFeatureChecker", ['AlertService', 'Principal', 'PackageFeatureListCustom', function (alertService, Principal, PackageFeatureListCustom) {
        return {
            restrict: 'AE',
            replace: 'false',
            template: "",
            link: function (scope, element, attrs) {

                var helpIcon = $('<a id="' + attrs.eoFeatureChecker + '"><span  class="special-feature-style glyphicon glyphicon-lock"><div class="special-feature-text">ویژه</div></span></a>');
                var accessType = attrs.eoFeatureChecker;
                checkAccess(accessType);
                // element.addClass('package-no-access');

                helpIcon.bind('click', function () {
                    alertService.showHelpMessage(helpIcon, 'feature-info.' + attrs.eoFeatureChecker);
                    //alert(attrs.eoHelpTooltip);
                })

                helpIcon.insertBefore(element);


                function setAccessToFeature() {

                    element.removeAttr("disabled", "disabled");
                    element.removeAttr("ng-disabled", "true");
                    var myEl = angular.element(document.querySelector('#' + accessType));
                    myEl.addClass('package-no-access');

                }

                function setNoAccessToFeature() {
                    element.attr("disabled", "disabled");
                    element.attr("ng-disabled", "true");

                }

                function checkAccess(reset) {
                    var result;

                    if (reset) {
                        setAccessToFeature();
                    }


                    var _company = Principal.getCurrentCompany();

                    PackageFeatureListCustom.getPackageFeatureListByCurrentCompany().query().$promise.then(function (result) {
                        Principal.setCurrentCompanyFeatureList(result);


                        var accessResult = Principal.hasSpecialFeatureAccess(accessType);
                        if (accessResult) {
                            setAccessToFeature();
                        } else {
                            setNoAccessToFeature();
                        }


                    });


                };

                //elem.bind('click', function () {
                //    elem.css('background-color', 'white');
                //    scope.$apply(function () {
                //        scope.color = "white";
                //    });
                //});
                //elem.bind('mouseover', function () {
                //    elem.css('cursor', 'pointer');
                //});
            }
        };
    }]);


(function () {
    'use strict';
    FeatureCheckerController.$inject = ['$scope', '$attrs', '$element', 'AlbumInfo', 'AlbumInfoExtend', 'DataUtils', '$timeout'];

    function FeatureCheckerController($scope, $attrs, $element, AlbumInfo, AlbumInfoExtend, DataUtils, $timeout) {
//
        var $ctrl = this;


    }


    var FeatureChecker = {
        // template:'tets:{{$ctrl.testStr}}',
        templateUrl: 'app/components/eyeson/feature-checker/eyeson.feature-checker.html',
        controller: FeatureCheckerController,
        bindings: {
            text: '@'
        }

    };

    angular
        .module('tikonApp')
        .component('eoFeatureChecker', FeatureChecker)


})();

